export enum CompanyTabEnum {
  FIND_CANDIDATES = 'Find Candidates',
  POST_A_JOB = 'Post a job',
  CULTURE_PROFILE = 'Culture Profile',
  CANDIDATE_OVERVIEW = 'Candidate overview',
  CAREER_PAGE = 'Career page'
}
